@if (meta) {
  <div class="page-bc">
    <span nz-icon [nzType]="meta.icon" class="page-bc-icon"></span>
    <span class="page-bc-title">{{ meta.title }}</span>
    @if (badge$ | async; as badge) {
      <span class="page-bc-badge" [title]="badge">
        <span nz-icon nzType="file-text"></span>
        {{ badge }}
      </span>
    }
  </div>
}
